var render = function (_h,_vm) {var _c=_vm._c;return _c('empty-content',{attrs:{"text":_vm.parent.$t('No messages yet')}})}
var staticRenderFns = []

export { render, staticRenderFns }